@let contactData = configuration().contactData;

<div class="item costum-mat-surface-container-lowest custom-elevation-z2">
    <div class="title-header costum-mat-primary-font-color"><span class="custom-title-large">Anschrift</span><mat-icon
            class="material-icons-outlined">location_on</mat-icon></div>
    <div class="contact-details">
        <div class="custom-body-medium emphasis">{{contactData.name}}</div>
        <div class="custom-body-medium">{{contactData.street}}</div>
        <div class="custom-body-medium">{{contactData.city}}</div>
        <div class="space"></div>

        @if (contactData.phone) {
            <div class="custom-body-medium icon-text-group"><mat-icon class="material-icons-outlined">call</mat-icon>
                {{contactData.phone}}
            </div>
        }
        @if (contactData.mobile){
            <div class="custom-body-medium icon-text-group"><mat-icon class="material-icons-outlined">smartphone</mat-icon>
                {{contactData.mobile}}
            </div>
        }
        @if (contactData.email) {
            <div class="custom-body-medium icon-text-group"><mat-icon class="material-icons-outlined">mail</mat-icon>
                {{contactData.email}}
            </div>
        }
    </div>
    <div class="contact-button-container">
        @if (contactData.phone || contactData.mobile) {
            <button mat-mini-fab class="costum-mat-surface-container-low" aria-label="Geschäft per Telefon kontaktieren"
                (click)="call()">
                <mat-icon class="material-icons-outlined">call</mat-icon>
            </button>
        }
        @if (contactData.email) {
            <button mat-mini-fab class="costum-mat-primary-container" aria-label="Geschäft per E-Mail kontaktieren"
                (click)="sendEmail()">
                <mat-icon class="material-icons-outlined">mail</mat-icon>
            </button>
        }      
    </div>
</div>